export default __webpack_public_path__ + "static/media/hotel_img_hi_06.96b1b615.jpg";